import { useContext } from "react";
import { ScenarioContext } from "../contexts/ScenarioContextDef";

export const useScenarios = () => {
  const context = useContext(ScenarioContext);
  if (context === undefined) {
    throw new Error("useScenarios must be used within a ScenarioProvider");
  }
  return context;
};
